import React from "react";
import { u2000BuildAppRouteHref } from "../../../u2000Core/tools/u2000OpenAppRouteInNewTab";
import { U2000_AGING_BUCKETS, type U2000AgingBucket } from "../../../u2000Core/constants/U2000AgingBuckets";
import { u3125FormatCurrency } from "../../U3125";
import type { U3125ArAgingInvoiceLine } from "../../U3125Service";
import {
  u3125ArAgingBucketColumnClass,
  U3125ArAgingBucketColumnCellLayout,
} from "./U3125ArAgingBucketTable";

export interface U3125ArAgingInvoiceBucketRowProps {
  invoice: U3125ArAgingInvoiceLine;
  selectedBucket?: U2000AgingBucket | null;
  showTotalsColumn?: boolean;
  firstInvoiceRow?: boolean;
  labelClassName?: string;
}

const U3125ArAgingInvoiceBucketRow: React.FC<U3125ArAgingInvoiceBucketRowProps> = ({
  invoice,
  selectedBucket = null,
  showTotalsColumn = true,
  firstInvoiceRow = false,
  labelClassName = "pl-6 border-l-2 border-gray-200 text-gray-700",
}) => {
  const rowPy = "py-0.5";
  const invoiceBorder = firstInvoiceRow ? "border-t-2 border-gray-200" : "border-t border-gray-100";
  const invoiceNumber = invoice.invoiceNumber != null ? String(invoice.invoiceNumber) : invoice.invoiceId;
  const bucketCode = String(invoice.bucket);

  return (
    <tr className={invoiceBorder}>
      <td className={`${rowPy} pr-2 font-medium whitespace-nowrap ${labelClassName}`}>
        {invoice.invoiceId ? (
          <a
            href={u2000BuildAppRouteHref(`/U3125/${invoice.invoiceId}`)}
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary-600 hover:underline"
            onClick={(e) => e.stopPropagation()}
          >
            {invoiceNumber}
          </a>
        ) : (
          invoiceNumber
        )}
      </td>
      {U2000_AGING_BUCKETS.map((code) => {
        const inBucket = bucketCode === code;
        return (
          <td
            key={`inv-${invoice.invoiceId}-${code}`}
            className={`${rowPy} px-1 text-right tabular-nums ${u3125ArAgingBucketColumnClass(code, selectedBucket)}`}
          >
            {inBucket ? (
              <U3125ArAgingBucketColumnCellLayout
                primary={u3125FormatCurrency(invoice.balanceDue)}
                reserveCountColumn
              />
            ) : (
              <U3125ArAgingBucketColumnCellLayout primary="" reserveCountColumn />
            )}
          </td>
        );
      })}
      {showTotalsColumn ? (
        <td className={`${rowPy} pl-2 text-right font-medium`}>
          <U3125ArAgingBucketColumnCellLayout
            primary={u3125FormatCurrency(invoice.balanceDue)}
            reserveCountColumn
          />
        </td>
      ) : null}
    </tr>
  );
};

export default U3125ArAgingInvoiceBucketRow;
